const logInvalidMethodCall = (methodName) => 
// eslint-disable-next-line no-console
console.log(`[Sentry] Unable to call "${methodName}". Sentry hasn't been initialized.`);
const logParamMissing = (methodName, param) => 
// eslint-disable-next-line no-console
console.log(`[Sentry] ${param} expected while calling the method [${methodName}]`);
export const setExtras = extraParams => {
    if (!window.Sentry) {
        logInvalidMethodCall('setExtra');
        return;
    }
    window.Sentry.setExtras(extraParams);
};
export const captureException = error => {
    if (!window.Sentry) {
        logInvalidMethodCall('captureException');
        return;
    }
    if (!error) {
        logParamMissing('captureException', 'error');
        return;
    }
    return window.Sentry.captureException(error);
};
//# sourceMappingURL=helpers.js.map